import {Stack, Button, Typography, Box, FormControl, InputLabel, Select, MenuItem} from '@mui/material';
import {msg} from "@lingui/macro";
import {useLingui} from "@lingui/react";
import {ArrowLeft, ArrowRight} from "@mui/icons-material";

const PaginationControls = ({ recordsCount,pageIndex, setPageIndex, maxPage, rowsPerPage,setRowsPerPage,pagesNumber }) => {
    const {_} = useLingui()
    return (
        <Stack
            direction="row"
            spacing={3}
            alignItems="center"
            justifyContent="space-between"
            padding={2}
            flexWrap="wrap"
        >
            {/* Select: Rows per page */}
            <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                    labelId="rows-per-page-label"
                    id="rows-per-page"
                    value={rowsPerPage}
                    label="Rows per page"
                    onChange={(e) => {
                        setPageIndex(0); // reset to first page
                        setRowsPerPage(parseInt(e.target.value, 10));
                    }}
                >
                    {[5, 10, 25, 50, 100].map((rows) => (
                        <MenuItem key={rows} value={rows}>
                            {rows}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Navigation Buttons */}
            <Stack direction="row" spacing={3} alignItems="center">
                <Button
                    variant="contained"
                    onClick={() => setPageIndex(pageIndex - 1)}
                    disabled={pageIndex <= 0}
                    color="primary"
                    title="Pagina precedente"
                    startIcon={<ArrowLeft />}
                    sx={{
                        borderRadius: '999px',
                        textTransform: 'none',
                        boxShadow: 2,
                        px: 2,
                    }}
                >
                    <Typography>{_(msg`Previous`)}</Typography>
                </Button>

                <Box>
                    <Typography  variant="body2" fontWeight="bold">
                        {_(msg`Pagina`)} <strong >{pageIndex + 1} / {pagesNumber} ({recordsCount && recordsCount} {_(msg`Rows`)})</strong>
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    onClick={() => setPageIndex(pageIndex + 1)}
                    disabled={pagesNumber === pageIndex + 1}
                    color="primary"
                    title="Pagina successiva"
                    endIcon={<ArrowRight />}
                    sx={{
                        borderRadius: '999px',
                        textTransform: 'none',
                        boxShadow: 2,
                        px: 2,
                    }}
                >
                    <Typography>{_(msg`Next`)}</Typography>
                </Button>
            </Stack>
        </Stack>
    );
};

export default PaginationControls;
